import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api, errText } from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";

const MSG = { confirmed: "You're subscribed to release alerts.", unsubscribed: "You've been unsubscribed. No more release alerts.", invalid: "That link is no longer valid." };

export function AlertSignup() {
  const { data: brands } = useFetch("/alerts/brands");
  const [sp] = useSearchParams();
  const [f, setF] = useState({ email: "", brands: [], website: "" });
  const [state, setState] = useState("idle");
  const flag = sp.get("alerts");
  useEffect(() => { if (MSG[flag]) toast[flag === "invalid" ? "error" : "success"](MSG[flag]); }, [flag]);
  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    try { await api.post("/alerts/subscribe", f); setState("sent"); } catch (err) { toast.error(errText(err)); setState("idle"); }
  };
  const toggle = (b) => setF({ ...f, brands: f.brands.includes(b) ? f.brands.filter((x) => x !== b) : [...f.brands, b] });
  return (
    <div className="panel p-6" data-testid="alert-signup">
      <p className="eyebrow mb-3 flex items-center gap-2"><BellRing className="h-3.5 w-3.5" />Release alerts</p>
      {MSG[flag] && <p className="mb-3 text-sm text-[color:var(--ice)]" data-testid="alert-signup-status">{MSG[flag]}</p>}
      {state === "sent" ? (
        <p className="text-sm text-slate-300" data-testid="alert-signup-sent">Check your inbox — click the link in our email to confirm your subscription.</p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <p className="text-sm text-slate-400">Get an email when new software versions are published.</p>
          <input type="email" required className="field" placeholder="you@company.co.uk" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="alert-signup-email" />
          <input type="text" tabIndex={-1} autoComplete="off" className="hidden" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} aria-hidden="true" />
          {brands?.length > 0 && (
            <div><p className="mb-1 text-xs text-slate-500">Only these brands (optional):</p>
              <div className="flex flex-wrap gap-2">{brands.map((b) => (
                <label key={b} className={`cursor-pointer border px-2.5 py-1 text-xs ${f.brands.includes(b) ? "border-[color:var(--ice)] text-[color:var(--ice)]" : "border-[color:var(--line-2)] text-slate-400"}`} data-testid={`alert-signup-brand-${b}`}>
                  <input type="checkbox" className="hidden" checked={f.brands.includes(b)} onChange={() => toggle(b)} />{b}</label>
              ))}</div></div>
          )}
          <button className="btn-ice w-full" disabled={state === "busy"} data-testid="alert-signup-submit">{state === "busy" ? "Sending…" : "Subscribe"}</button>
          <p className="text-[11px] text-slate-500">Double opt-in. Unsubscribe in one click from any email.</p>
        </form>
      )}
    </div>
  );
}
